const EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

export const maskEmailIds = (text: string): string => text.replace(EMAIL_REGEX, '***@***');
